export const tooltipStyle = (c) => ({
  contentStyle: {
    background: c.card, border: "1px solid " + c.border,
    borderRadius: 10, fontSize: 13, boxShadow: "0 4px 16px rgba(0,0,0,0.15)",
  },
  labelStyle: { fontWeight: 600, color: c.fg },
  itemStyle: { color: c.muted },
});
